<header
  class="w-full flex flex-column gap-2 bg-white border-x-2 border-200 justify-content-center lg:justify-start header">
  <div class="w-full flex align-items-end gap-2 lg:pl-2">
    <a routerLink="/">
      <img src="https://traefik.casan.com.br/static/imagens/casan.svg" class="logo border-200" />
    </a>
    <span class="font-bold text-primary text-xl">
      Companhia Catarinense<br />de Águas e Saneamento
    </span>
    <div class="flex-1 flex flex-column align-items-end h-full mt-2" *ngIf="isAcessoInterno">
      <span *ngIf="isLoggedIn" class="mr-2 text-primary">Olá <span class="font-bold ">{{profile.firstName + ' ' +
          profile.lastName}}</span></span>
      <div>
        <a routerLink="/interno" class="ml-auto mr-2 text-primary underline">Acesso Restrito</a>
        <button *ngIf="isLoggedIn" (click)="logout()" class="mr-2 text-primary p-link underline">Sair</button>
      </div>
    </div>
  </div>
  <div class="h-1rem bg-primary w-full">
  </div>
</header>